import { render, staticRenderFns } from "./demo-form.vue?vue&type=template&id=2c521271&scoped=true&"
import script from "./demo-form.vue?vue&type=script&lang=js&"
export * from "./demo-form.vue?vue&type=script&lang=js&"
import style0 from "./demo-form.vue?vue&type=style&index=0&id=2c521271&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c521271",
  null
  
)

export default component.exports